export enum PlantType {
  Pto = 1,
  Ieo = 2,
  Transmission = 4,
  BlueOval = 8,
  Illp = 16,
}

export const plantTypeAsString = new Map([
  [0, "-"],
  [PlantType.BlueOval, "Blue Oval"],
  [PlantType.Ieo, "IEO"],
  [PlantType.Illp, "ILLP"],
  [PlantType.Pto, "PTO"],
  [PlantType.Transmission, "Transmission"],
]);

export const plantTypeAsStringForAffectedPartDestination = new Map([
  [PlantType.BlueOval, "Blue Oval"],
  [PlantType.Ieo, "IEO"],
  [PlantType.Pto, "PTO"],
  [PlantType.Transmission, "Transmission"],
]);
